export default "__VITE_ASSET__DtSY2k8x__"